/**
 * @generated SignedSource<<fd592c0e1304b6609dcb6656f6165c63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RingSizeDisplay_transaction$data = {
  readonly buyerCurrency: Currency | null;
  readonly sku: {
    readonly ringSizeDisplay: {
      readonly mm: string | null;
      readonly us: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "RingSizeDisplay_transaction";
};
export type RingSizeDisplay_transaction$key = {
  readonly " $data"?: RingSizeDisplay_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"RingSizeDisplay_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RingSizeDisplay_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "buyerCurrency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "sku",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SkuRingSizeDisplay",
          "kind": "LinkedField",
          "name": "ringSizeDisplay",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mm",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "us",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "5b35c990f3326100e8ee70b0c81fae6a";

export default node;
